export const frontmatter = {
  title: "Welcome to Scale Farm",
  order: 1,
}

![](https://scale.farm/scale/scale-police-banner.png)

## Introduction

Scale.Farm was derived from the initial concept of Andre Cronje. The mechanism used to create a perpetual decentralized exchange was unique and ingenious. This platform takes that concept and applies it to a more user-friendly DEX. Scale.Farm serves as the trading mechanism for the Base network, utilizing the Solidly perpetual model with optimized fee structures and emissions.

## Why Scale.Farm

The perpetual model is the first of its kind that can sustain an emission token price. Our goal is to create an equalized effect across rewards for token holders and incentives for LP providers.

Our model achieves this by rewarding liquidity with a valuable token that provides income similar to the Curve model. The fee structure ensures that the utility and reward for holding and locking the token is high enough to support the required liquidity for low slippage trades.

## Fee Structure and Slippage

Charging a low fee (e.g., 0.01%) is a flawed concept unless the volume warrants the incentive required to maintain sufficient TVL, especially for volatile pairs. This creates a downward spiral in the native token price, destroying the platform's ability to maintain liquidity.
A fee of 0.01% becomes irrelevant when slippage in the trade is 2% or 3%. Maintaining a fee structure that supports low slippage trades is essential. This provides better results and a superior experience for traders.

## Where To Find Us

- Twitter: [https://twitter.com/BuildersAtScale](https://twitter.com/BuildersAtScale)
- Discord: [https://discord.gg/PqggXcYtYS](https://discord.gg/PqggXcYtYS)
